/**
 * Gets and process the window.location.query into an object and publishes it on message bus
 *
 * @internals app/components/UrlQueryStringProvider
 */
import _ from 'lodash';
import MessageBusTopics from '../../common/MessageBusTopics';

/**
 * Global PubSub reference
 *
 * @type {Object}
 *
 * @private
 */
var pubSub;

/**
 * Splitting a key value pair string and returns it as an object
 *
 * @param {string} keyValuePair  eg: 'action=search'
 * @returns {object}
 */
var keyValueProcess = function keyValueProcess(keyValuePair) {

    var keyAndValue = keyValuePair.split('=');
    this[decodeURIComponent(keyAndValue[0])] = decodeURIComponent(keyAndValue[1]);

    return this;
};

/**
 * Translates the query string to object
 *
 * @param {string} query Query string (eg: ?action=search&query=Manchester%20United)
 *
 * @returns {object} Key - value pairs (eg: {action: "search", query: "Manchester United"})
 */
var getQueryParams = function getQueryParams(query) {

    var queryParams = query
        .replace(/(^\?)/, '')
        .split('&')
        .map(keyValueProcess.bind({}));

    return queryParams[0];
};

/**
 * Publishing the query string content on the message bus with action as postfix on the event name.
 *
 * @returns {boolean}
 */
var publishQueryStringChanges = function publishQueryStringChanges(queryString) {

    var topic = MessageBusTopics.NAVIGATION_QUERY_STRING;
    var query = _.clone(queryString);

    if (queryString.action) {
        topic += '.' + queryString.action;

        delete query.action;

        pubSub.publishSticky(topic, query);

        return true;
    }

    return false;
};

/**
 * Public functions.
 *
 * @type {Object}
 */
var api = {
    /**
     * Sets the initial query string from the URL
     *
     * @param {object} [messageBus] site wide used pub-sub service
     *
     * @returns {void}
     *
     * @public
     */
    init: function init(messageBus) {

        pubSub = messageBus;
        api.update();
    },

    /**
     * Gets the query params from the passed query string
     *
     * @param {string} [query] Query string to get the QueryParams from
     *
     * @returns {void}
     *
     * @public
     */
    update: function update(query) {

        if (!query) {
            query = window.location.search;
        }

        var queryString = getQueryParams(query);

        publishQueryStringChanges(queryString);
    },

    getQueryParams: getQueryParams,
};

export default api;
